import React from 'react'
import { t } from '@lingui/core/macro'
import ArrowButton from '../ArrowButton/ArrowButton'
import { PaymentMethodType } from '../../types/paymentPageInfo'
import { ReactComponent as PixIcon } from '../../assets/pix.svg'
import { ReactComponent as GoogleIcon } from '../../assets/google.svg'
import apple from '../../assets/apple.png'
import samsungPay from '../../assets/samsung-pay.png'
import styles from './PaymentMethodList.module.css'

const AppleIcon = () => (
    <img src={apple} alt="Mac" style={{ width: 'calc(var(--button-arrow-icon-size) * 1.25)', marginBottom: 'calc(var(--font-size-sm) / 4 * -1)', marginRight: 'calc(var(--spacing-md) / 6 * -1)', marginLeft: 'calc(var(--spacing-md) / 6 * -1)' }} />
)

const SamsungIcon = () => (
    <img src={samsungPay} alt="SamsungPay" style={{ width: 'var(--button-arrow-icon-size)', marginBottom: 'calc(var(--font-size-sm) / 6 * -1)', marginTop: 'calc(var(--font-size-sm) / 6)' }} />
)

const paymentMethodDescriptions: Record<string, { name: string, icon: React.ReactNode|string }> = {
    card: { name: t`Платеж по карте`, icon: '💳' },
    p2p: { name: t`Перевод на карту`, icon: '🏦' },
    sbp: { name: t`СБП`, icon: '📱' },
    pix: { name: 'PIX', icon: <PixIcon /> },
    apple: { name: 'Apple Pay', icon: <AppleIcon /> },
    google: { name: 'Google Pay', icon: <GoogleIcon /> },
    samsung: { name: 'Samsung Pay', icon: <SamsungIcon /> },
}

interface PaymentMethodListProps {
    paymentMethodTypes: PaymentMethodType[]
    handlePaymentMethodClick: (method: string) => void
}

const PaymentMethodList = ({ paymentMethodTypes, handlePaymentMethodClick }: PaymentMethodListProps ) => {
    return (
        <div className={styles.section}>
            <h2 className={styles.paymentMethodsTitle}>{t`Способ оплаты`}</h2>
            <div className={styles.paymentMethods}>
                {paymentMethodTypes.map((methodType) => {
                    const method = paymentMethodDescriptions[methodType.type]
                    const available = true

                    return (
                        <ArrowButton
                            key={methodType.type}
                            icon={method.icon}
                            name={method.name}
                            onClick={() => available && handlePaymentMethodClick(methodType.type)}
                            disabled={!available}
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default PaymentMethodList
